import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedRightFlippedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.66 13.46V19H5.66V13.46C5.66 10.4 7.98 8.04 11.04 8.04H15.88L11.7 3.92L12.98 2.64L19.34 9L12.98 15.36L11.7 14.08L15.88 9.96H11.04C9.16 9.96 7.66 11.52 7.66 13.46Z" />
    </SvgIcon>
  );
});
